import { render, staticRenderFns } from "./SbpPaymentCheckModal.vue?vue&type=template&id=241ad44a"
import script from "./SbpPaymentCheckModal.vue?vue&type=script&lang=js"
export * from "./SbpPaymentCheckModal.vue?vue&type=script&lang=js"
import style0 from "./SbpPaymentCheckModal.vue?vue&type=style&index=0&id=241ad44a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports